import { containerConnect } from "@configuratorware/configurator-frontendgui/Framework/ComponentContainer";
import ProductPartsList from "../../Components/CustomProductPartsList";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import { getComponent } from "@configuratorware/configurator-frontendgui/App/configuration";
import CallToAction from "@configuratorware/configurator-frontendgui/App/Shared/Components/CallToAction";
import memoize from "@configuratorware/configurator-frontendgui/Utils/Function/memoize";

const removeHiddenComponents = memoize((components) =>
  components.filter(({ hiddenInFrontend }) => !hiddenInFrontend)
);

const mapStateToProps = ({ configurator, device, ui }) => {
  const dock = getConf("dock");

  return {
    Component: ProductPartsList,
    CallToActionComponent: getComponent("StartHere") || CallToAction,
    displaySwitchedOptions: getConf("displaySwitchedOptions"),
    optionclassifications: removeHiddenComponents(
      configurator.filteredOptionclassifications
    ),
    selectedoptionclassification: configurator.selectedoptionclassification,
    showStartHere: ui.visibilityMap.startHere,
    vertical: dock
      ? dock === "left"
      : device.screen.orientation === "landscape",
  };
};

const mapDispatchToProps = () => ({});

export default containerConnect(mapStateToProps, mapDispatchToProps);
